import { render, staticRenderFns } from "./clubList.vue?vue&type=template&id=2e42e81b&scoped=true&"
import script from "./clubList.vue?vue&type=script&lang=js&"
export * from "./clubList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42e81b",
  null
  
)

export default component.exports